<template>
  <div class="admin-shell">
    <aside class="admin-sidebar">
      <router-link class="admin-logo-top" to="/admin" aria-label="后台首页">
        <img class="admin-logo" src="/assets/admin-logo.svg" alt="晴屿集后台">
      </router-link>
        <el-menu
        class="admin-menu"
        :default-active="activeMenu"
        :default-openeds="['content', 'skills']"
        router
        @select="handleMenuSelect"
      >
        <el-menu-item index="/admin">
          <i class="el-icon-data-board"></i>
          <span slot="title">仪表盘</span>
        </el-menu-item>

        <el-submenu index="content">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>内容管理</span>
          </template>
          <el-menu-item index="/admin/articles">文章列表</el-menu-item>
          <el-menu-item index="/admin/articles/new">发布文章</el-menu-item>
          <el-menu-item index="/admin/categories">分类管理</el-menu-item>
        </el-submenu>

        <el-submenu index="skills">
          <template slot="title">
            <i class="el-icon-collection"></i>
            <span>SKILL管理</span>
          </template>
          <el-menu-item index="/admin/skills">SKILL列表</el-menu-item>
          <el-menu-item index="/admin/skills/publish">SKILL发布</el-menu-item>
        </el-submenu>

        <el-menu-item index="/admin/menus">
          <i class="el-icon-menu"></i>
          <span slot="title">菜单管理</span>
        </el-menu-item>

        <el-menu-item index="/admin/site-settings">
          <i class="el-icon-setting"></i>
          <span slot="title">站点设置</span>
        </el-menu-item>

        <el-menu-item index="/admin/profile">
          <i class="el-icon-user"></i>
          <span slot="title">个人信息</span>
        </el-menu-item>

        <el-menu-item index="/admin/operation-logs">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">用户日志</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <section class="admin-main">
      <header class="admin-header">
        <div>
          <p class="eyebrow">数据管理后台</p>
          <h1>内容运营中心</h1>
        </div>
        <div class="admin-actions">
          <el-button @click="goFrontend">查看前台</el-button>
          <el-button type="danger" plain @click="logout">退出登录</el-button>
        </div>
      </header>

      <router-view />
    </section>
  </div>
</template>

<script>
import { logoutAdmin } from '@/services/auth';
import { trackFrontendEvent } from '@/services/operationLogs';

const menuLabels = {
  '/admin': '仪表盘',
  '/admin/articles': '文章列表',
  '/admin/articles/new': '发布文章',
  '/admin/categories': '分类管理',
  '/admin/menus': '菜单管理',
  '/admin/skills': 'SKILL列表',
  '/admin/skills/publish': 'SKILL发布',
  '/admin/site-settings': '站点设置',
  '/admin/profile': '个人信息',
  '/admin/operation-logs': '用户日志',
};

export default {
  name: 'AdminLayout',
  computed: {
    activeMenu() {
      if (this.$route.path.startsWith('/admin/articles/')) {
        return this.$route.path === '/admin/articles/new' ? '/admin/articles/new' : '/admin/articles';
      }

      if (this.$route.path.startsWith('/admin/skills/')) {
        if (this.$route.path === '/admin/skills/publish') {
          return '/admin/skills/publish';
        }
        return '/admin/skills';
      }

      return this.$route.path;
    },
  },
  methods: {
    goFrontend() {
      trackFrontendEvent({
        operation: '查看前台',
        pagePath: this.$route.path,
        detail: '用户点击后台顶部查看前台按钮',
        success: true,
      });
      this.$router.push('/');
    },
    handleMenuSelect(index) {
      trackFrontendEvent({
        operation: `点击菜单：${menuLabels[index] || index}`,
        pagePath: index,
        detail: `用户点击后台侧边栏菜单「${menuLabels[index] || index}」`,
        success: true,
      });
    },
    async logout() {
      try {
        await this.$confirm('确定要退出当前后台账号吗？', '退出登录确认', {
          confirmButtonText: '退出登录',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }

      await trackFrontendEvent({
        operation: '退出登录',
        pagePath: this.$route.path,
        detail: '用户点击退出登录按钮并确认退出',
        success: true,
      });
      await logoutAdmin();
      this.$router.replace('/admin/login');
    },
  },
};
</script>

<style scoped>
.admin-menu {
  background: transparent;
  border-right: 0;
}

.admin-menu ::v-deep .el-menu-item,
.admin-menu ::v-deep .el-submenu__title {
  height: 46px;
  margin: 6px 0;
  color: #31576d;
  border-radius: 14px;
  line-height: 46px;
  transition: background .18s ease, box-shadow .18s ease, transform .18s ease, color .18s ease;
}

.admin-menu ::v-deep .el-menu,
.admin-menu ::v-deep .el-submenu .el-menu {
  background: transparent;
}

.admin-menu ::v-deep .el-menu-item:hover,
.admin-menu ::v-deep .el-submenu__title:hover {
  color: #0f6f9d;
  background: rgba(255,255,255,.78);
  box-shadow: 0 10px 24px rgba(22,119,183,.14);
  transform: translateY(-1px);
}

.admin-menu ::v-deep .el-menu-item.is-active {
  color: #143047;
  background: linear-gradient(135deg,#fff4bd 0%,#dff8ff 100%) !important;
  box-shadow: 0 12px 26px rgba(22,119,183,.18);
  font-weight: 700;
}

.admin-menu ::v-deep .el-submenu__title i,
.admin-menu ::v-deep .el-menu-item i {
  color: inherit;
}
</style>
